import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 32px;
  height: 40px;
  width: 80%;
  padding: 0 32px;
`;

export const ContentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  background: var(--white-one-negative);
  border-radius: 50%;
`;
